import ActionTypes from './actionTypes';

/**
 * Get Everyday Rewards enrolment status
 * */
export function getEverydayRewardsEnrolmentStatus(grandParentAccountNumber, contractIdentifier, isLinking=false) {
  return {
    type: ActionTypes.EVERYDAY_REWARDS.ENROLMENT_STATUS.REQUEST,
    payload:{
      grandParentAccountNumber: grandParentAccountNumber,
      contractIdentifier: contractIdentifier, 
      isLinking: isLinking,
    }
  };
}

export function getEverydayRewardsEnrolmentStatusSuccess(response) {
  return {
    type: ActionTypes.EVERYDAY_REWARDS.ENROLMENT_STATUS.SUCCESS,
    payload: {
      everydayRewardsEnrolmentStatus: response
    },
  };
}

export function getEverydayRewardsEnrolmentStatusFailure() {
  return {
    type: ActionTypes.EVERYDAY_REWARDS.ENROLMENT_STATUS.FAILURE
  };
}

/**
 * Get Everyday Rewards Login URI
 * */
export function getEverydayRewardsLoginUri(state) {
  return {
    type: ActionTypes.EVERYDAY_REWARDS.LOGIN_URI.REQUEST,
    payload:{
      state: state
    }
  };
}

export function getEverydayRewardsLoginUriSuccess(response) {
  return {
    type: ActionTypes.EVERYDAY_REWARDS.LOGIN_URI.SUCCESS,
    payload: {
      everydayRewardsLoginUri: response.loginUri
    },
  };
}

export function getEverydayRewardsLoginUriFailure() {
  return {
    type: ActionTypes.EVERYDAY_REWARDS.LOGIN_URI.FAILURE
  };
}

/**
 * Connect to Everyday Rewards
 * */
export function everydayRewardsConnect(grandparentAccountNumber, contractIdentifier, authorizationCode) {
  return {
    type: ActionTypes.EVERYDAY_REWARDS.CONNECT.REQUEST,
    payload:{
      grandparentAccountNumber: grandparentAccountNumber,
      contractIdentifier: contractIdentifier,
      authorizationCode: authorizationCode
    }
  };
}

export function everydayRewardsConnectSuccess() {
  return {
    type: ActionTypes.EVERYDAY_REWARDS.CONNECT.SUCCESS,
  };
}

export function everydayRewardsConnectFailure() {
  return {
    type: ActionTypes.EVERYDAY_REWARDS.CONNECT.FAILURE
  };
}

/**
 * Disconnect from Everyday Rewards
 * */
export function everydayRewardsDisconnect(grandparentAccountNumber, contractIdentifier) {
  return {
    type: ActionTypes.EVERYDAY_REWARDS.DISCONNECT.REQUEST,
    payload:{
      grandparentAccountNumber: grandparentAccountNumber,
      contractIdentifier: contractIdentifier
    }
  };
}

export function everydayRewardsDisconnectSuccess() {
  return {
    type: ActionTypes.EVERYDAY_REWARDS.DISCONNECT.SUCCESS,
  };
}

export function everydayRewardsDisconnectFailure() {
  return {
    type: ActionTypes.EVERYDAY_REWARDS.DISCONNECT.FAILURE
  };
}
